module.exports = __webpack_public_path__ + "static/img/image046.96f8441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image046.png
// module id = lkoy
// module chunks = 1